export default __webpack_public_path__ + "static/media/kalechips-wide.adf8fec6.jpg";